<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M12.7993 6L16 9M16 9L12.7993 12M16 9L2 9"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
  export default {
    name: 'ArrowRightIcon',
  };
</script>
